// src/utils/Convert.ts

// Function to manually track page views
export const trackPageView = (path: string): void => {
    if (window.convert && typeof window.convert.sendPageViewEvent === 'function') {
        window.convert.sendPageViewEvent(path);
    } else {
        // If Convert isn't loaded yet, retry after a short delay
        setTimeout(() => trackPageView(path), 500);
    }
};

// Function to track custom events
export const trackEvent = (eventName: string, eventData: object = {}): void => {
    if (window.convert && typeof window.convert.sendCustomEvent === 'function') {
        window.convert.sendCustomEvent(eventName, eventData);
    }
};